import { domain } from 'modules/data';
import { FC, memo, useMemo } from 'react';

import FieldsSection from '../../../components/FieldsSection';
import { SectionContainer } from '../../../components/SectionContainer/SectionContainer';
import { excludedKeys } from './QBooksSalesInvoiceShippingDetails.constants';
import { messages } from './QBooksSalesInvoiceShippingDetails.messages';
import { QBooksSalesInvoiceShippingDetailsProps } from './QBooksSalesInvoiceShippingDetails.types';

export const QBooksSalesInvoiceShippingDetails: FC<QBooksSalesInvoiceShippingDetailsProps> = memo((props) => {
    const { details } = props;

    const isShippingDetailsAvailable = useMemo(
        () =>
            (Object.entries(details.shipping) as [keyof domain.QBooksSalesInvoiceShipping, unknown][]).some(
                ([key, value]) => !excludedKeys.includes(key) && Boolean(value)
            ),
        [details.shipping]
    );

    if (!isShippingDetailsAvailable) {
        return null;
    }

    return (
        <SectionContainer title={messages.sectionTitle} noPadding withHeaderPadding>
            <FieldsSection>
                <FieldsSection.Field title={messages.shippingToFieldTitle} value={details.shipping.address} />

                <FieldsSection.Field title={messages.shipViaFieldTitle} value={details.shipping.method} />

                <FieldsSection.Field
                    title={messages.shippingDateFieldTitle}
                    valueType={FieldsSection.Field.ValueType.Date}
                    value={details.shipping.date}
                />

                <FieldsSection.Field
                    title={messages.trackingNumberFieldTitle}
                    value={details.shipping.trackingNumber}
                />

                <FieldsSection.Field title={messages.shippingFromFieldTitle} value={details.shipping.fromAddress} />
            </FieldsSection>
        </SectionContainer>
    );
});

QBooksSalesInvoiceShippingDetails.displayName = 'QBooksSalesInvoiceShippingDetails';
